<template>
  <page>
    <template slot="content">
      <help-content :title="'ホームとランキング画面歩数が異なる原因'">
        <template slot="content">
          <div class="text">
            ホームに表示されている歩数をサーバーに送られてから、計算した結果がランキングとイベント画面に反映されます。そのため、ランキング／イベント画面の歩数が少し遅れて更新されます。
          </div>
        </template>
      </help-content>
    </template>
  </page>
</template>

<script>
  import HelpContent from '@/components/HelpContent'
  import Page from '@/components/Page'

  export default {
    components: {
      HelpContent,
      Page
    },
    mounted () {
      window.scrollTo(0, 0)
    }
  }
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/pages/Help14.vue